import { useEffect, useLayoutEffect, useCallback } from "react";
import { useBlocker } from "react-router-dom";

/**
 * Blocks in-app navigation when `when` is true and warns on tab close / refresh.
 * Use with react-hook-form `isDirty` or any other "unsaved work" flag.
 */
export function useUnsavedChangesBlocker({ when }) {
  const blocker = useBlocker(useCallback(() => when, [when]));

  // When the form is no longer dirty, `when` becomes false but the router can still
  // be in "blocked" until reset(). Clear it so the UI and navigation stay in sync
  // (e.g. after Save Changes while the confirmation dialog was open).
  useLayoutEffect(() => {
    if (!when && blocker.state === "blocked") {
      blocker.reset?.();
    }
  }, [when, blocker.state, blocker]);

  useEffect(() => {
    if (!when) return undefined;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when]);

  return blocker;
}
